
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyIcon as SkyIconElement } from '@sky.ui/core/sky-icon';
 
 
 
 

 
 export const SkyIcon = createComponent({
   displayName: 'SkyIcon',
   react: React,
   tagName: 'sky-icon',
   elementClass: SkyIconElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-icon';
